import { POUNDS_TO_KG_CONVERSION } from "constants/unit-conversions.constant";

export const convertPoundsToKilos = (pounds: number): number => {
  return pounds * POUNDS_TO_KG_CONVERSION;
};

export const convertKilosToPounds = (kilos: number): number => {
  return parseFloat((kilos / POUNDS_TO_KG_CONVERSION).toFixed(2));
};
